import { useMemo } from "react";
import { useLocalization } from "@fluent/react";

export const useQuickActionLabel = (
  action: API.QuickActionItem,
): string => {
  const { l10n } = useLocalization();

  return useMemo(() => 
    // eslint-disable-next-line narmi-ftl/ids-must-be-literals
     l10n.getString(`quick-action-${action.key}`, {}, action.label)
  , [l10n, action.key, action.label]);
};

export default null;